import { ReactNode } from 'react';

interface ConstrainWrapperProps {
  children: ReactNode | string | undefined;
  maxWidth?: string;
  sx?: React.CSSProperties;
}

const ConstrainWrapper = ({
  children,
  maxWidth = '85px',
  sx = {},
}: ConstrainWrapperProps) => (
  <div
    style={{
      maxWidth: maxWidth,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      ...sx,
    }}
    title={typeof children === 'string' ? children : undefined}
  >
    {children}
  </div>
);

export default ConstrainWrapper;
